import { z } from 'zod';
import { cpf, cnpj } from 'cpf-cnpj-validator';

export const CPFSchema = z
  .string()
  .transform((s) => s.replace(/\D/g, ''))
  .refine((s) => cpf.isValid(s), { message: 'CPF inválido' });

export const CNPJSchema = z
  .string()
  .transform((s) => s.replace(/[^A-Za-z0-9]/g, '').toUpperCase())
  .refine((s) => cnpj.isValid(s), { message: 'CNPJ inválido' });

export const OptionalCNPJSchema = z.preprocess(
  (v) => (typeof v === 'string' && v.trim() === '' ? undefined : v),
  CNPJSchema.optional(),
);

export const EmailSchema = z.email({ message: 'E-mail inválido' }).toLowerCase();

export const PhoneBRSchema = z
  .string()
  .transform((s) => s.replace(/\D/g, ''))
  .refine((s) => /^[1-9]{2}9\d{8}$/.test(s), {
    message: 'Telefone inválido (DDD + 9 + 8 dígitos)',
  });

export const BrazilianDateSchema = z.iso.datetime();

export const BRLCentsSchema = z.number().int().nonnegative();

// Alias kept for plan-level naming compatibility
export const BrlCentsSchema = BRLCentsSchema;
